import React from "react";
import {
  Campuses,
  ContactForm,
  CourseFinder,
  Footer,
  FreeAssessment,
  Header,
  Hero,
  WhyCsSection,
} from "../../components";

// Landing page, laid out like mq.edu.au: hero, the course finder panel over
// its bottom edge, two action boxes, "why", then campuses and contact. Sections
// that would need results, testimonials or teacher photos are left out until
// there is real material for them.
function Home() {
  return (
    <div style={{ background: "#ffffff" }}>
      <Header />

      <main>
        <Hero />
        <div id="course-finder">
          <CourseFinder />
        </div>
        <FreeAssessment flush />
        <WhyCsSection />
        <Campuses />
        <section style={{ background: "#F7F6F2", padding: "72px 0 84px" }}>
          <div style={{ maxWidth: 900, margin: "0 auto", padding: "0 24px" }}>
            <ContactForm />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Home;
